<!-- Controls -->
<div class="flex flex-wrap items-end gap-3 bg-white rounded-lg border border-gray-200 p-3 mb-4">
  <div class="w-full sm:w-80">
    <label class="block text-xs font-semibold text-gray-500 uppercase mb-1">Campaign</label>
    <app-select-input [options]="campaignOptions" [(ngModel)]="campaignId" (ngModelChange)="reload()"></app-select-input>
  </div>
  <p class="text-xs text-gray-500 flex-1 min-w-48">
    For a fair test, pick a campaign marked <span class="font-semibold">(both CTAs)</span>: same creative, audience and budget,
    with only the destination different.
  </p>
</div>

<div *ngIf="errorMessage" class="bg-red-50 text-red-700 border border-red-200 rounded-md px-4 py-3 mb-4 text-sm">
  <i class="fas fa-exclamation-circle mr-1"></i> {{ errorMessage }}
</div>

<div *ngIf="loading" class="text-center text-gray-500 py-10">
  <i class="fas fa-spinner fa-spin mr-1"></i> Loading comparison...
</div>

<div *ngIf="!loading && report">
  <div *ngIf="!whatsApp?.adCount && !web?.adCount" class="bg-white rounded-lg border border-gray-200 p-6 text-center text-gray-500 text-sm mb-4">
    No WhatsApp-CTA or website-CTA Meta ad spent or brought a lead in this period.
  </div>

  <div *ngIf="whatsApp?.adCount || web?.adCount">
    <div class="bg-amber-50 border border-amber-200 text-amber-800 rounded-md px-4 py-3 mb-4 text-sm">
      <i class="fas fa-info-circle mr-1"></i>
      A WhatsApp lead is anyone who sent a first message; a website lead has already signed in with their phone.
      Judge the CTAs on cost per sign-up, booking and first pickup, not cost per lead.
    </div>

    <div class="bg-white rounded-lg border border-gray-200 mb-4 overflow-x-auto">
      <table class="min-w-full text-sm">
        <thead class="bg-gray-50 text-xs text-gray-500 uppercase">
          <tr>
            <th class="text-left px-3 py-2">Metric</th>
            <th class="text-right px-3 py-2"><i class="fab fa-whatsapp text-green-600 mr-1"></i> WhatsApp CTA</th>
            <th class="text-right px-3 py-2"><i class="fas fa-globe text-blue-600 mr-1"></i> Website CTA</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let metric of metrics" class="border-t border-gray-100">
            <td class="px-3 py-2 text-gray-900">
              {{ metric.label }}
              <div *ngIf="metric.note" class="text-xs text-gray-400">{{ metric.note }}</div>
            </td>
            <td *ngFor="let side of [whatsApp, web]; let i = index" class="px-3 py-2 text-right whitespace-nowrap"
              [class.bg-green-50]="winner(metric) === (i === 0 ? 'whatsapp' : 'web')"
              [class.font-semibold]="winner(metric) === (i === 0 ? 'whatsapp' : 'web')">
              <ng-container *ngIf="value(side, metric.key) as v; else zeroOrEmpty">
                <ng-container [ngSwitch]="metric.format">
                  <span *ngSwitchCase="'currency'">{{ v | currency:'INR':'symbol':'1.0-0' }}</span>
                  <span *ngSwitchCase="'roas'">{{ v }}×</span>
                  <span *ngSwitchCase="'days'">{{ v }} days</span>
                  <span *ngSwitchDefault>{{ v | number }}</span>
                </ng-container>
                <span *ngIf="metric.rateKey && value(side, metric.rateKey) != null" class="text-xs text-gray-400">
                  ({{ value(side, metric.rateKey) }}%)
                </span>
                <i *ngIf="winner(metric) === (i === 0 ? 'whatsapp' : 'web')" class="fas fa-check text-green-600 ml-1" title="Better"></i>
              </ng-container>
              <ng-template #zeroOrEmpty>
                <span class="text-gray-400">{{ value(side, metric.key) === 0 ? '0' : '—' }}</span>
              </ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <p class="text-xs text-gray-400 leading-relaxed">
    Each Meta ad's CTA comes from its ad set's destination in Meta; when that's missing, from where its leads arrived.
    Leads are grouped by first-touch date, and their sign-ups, bookings and pickups count within {{ report.attributionWindowDays }} days.
    <ng-container *ngIf="unknown">
      {{ unknown.spend | currency:'INR':'symbol':'1.0-0' }} was spent on {{ unknown.adCount }} ad(s) with no known destination, left out of both columns.
    </ng-container>
  </p>
</div>
